import React from "react";
import { Button, Col, Container, FormLabel, Row } from "react-bootstrap";
import {
  RestPageListBean,
  RestSkuBatchInventoryListRequest,
  SKUBatchInventorySearchCriteria,
} from "../ds/ds.js";
import { LookupHandler, LookupResultDetails } from "../ds/lookup_ds.js";
import { Eraser, TickIcon } from "../gui_components/Icons.js";
import { InputTextbox, ShowError } from "../gui_components/UIComponents.js";
import { InventoryService } from "../services/InventoryService.js";
import { isEmptyString } from "../gui_components/Util.js";
export class RollSkuLookupHandler extends LookupHandler {
  constructor(
    companyCode,
    attribute_name,
    fabricCode,
    colorCode,
    purchaseReceiptNumber,
  ) {
    super();
    this.attribute_name = attribute_name;
    this.lookupTitle = attribute_name + " Lookup";
    this.companyCode = companyCode;
    this.fabricCode = fabricCode;
    this.colorCode = colorCode;
    this.purchaseReceiptNumber = purchaseReceiptNumber;
    let resetCriteria = new SKUBatchInventorySearchCriteria();
    resetCriteria.companyCode = companyCode;
    this.resetCriteria = resetCriteria;
    let newCriteria = new SKUBatchInventorySearchCriteria();
    newCriteria.companyCode = companyCode;
    this.newCriteria = newCriteria;
    let rollSkuLookupCriteria = new SKUBatchInventorySearchCriteria();
    rollSkuLookupCriteria.companyCode = this.companyCode;
    let lookupCriteriaView = RollSkuLookupCriteraHandler(
      companyCode,
      rollSkuLookupCriteria,
    );
    let lookupDataCallback = function (
      lookup_dialog,
      page_number,
      searchCriteria,
      filterText,
    ) {
      this.fetchDataFromService(
        lookup_dialog,
        page_number,
        searchCriteria,
        filterText,
      );
    };
    this.setDetails(
      lookupDataCallback,
      rollSkuLookupCriteria,
      lookupCriteriaView,
    );
    this.initColumns();
  }
  initColumns() {
    this.addColumnDefinition(this.attribute_name, "rollSkuNumber", 0, true); //1
    this.addColumnDefinition("Roll", "rollNumber", 0, false); //2
    this.addColumnDefinition("Location", "locationCode", 0, false); //3
    this.addColumnDefinition("VendorLot", "vendorBatchNumber", 0, false); //4
    this.addColumnDefinition("Box", "boxNumber", 0, false); //5
    this.addColumnDefinition("OnhandQty", "onHandQuantity", 0, false); //6
    this.addColumnDefinition("PO#", "purchaseOrderNumber", 0, false); //7
    this.addColumnDefinition("PR#", "purchaseOrderReceiptNumber", 0, false); //8
  }
  loadRollSkuList = (lookup_dialog, pageNumber, searchCriteria) => {
    let rollsku_criteria = new SKUBatchInventorySearchCriteria(); //To be fetched from CriteriaHandler
    rollsku_criteria.companyCode = this.companyCode;
    rollsku_criteria.fabricStyleCode = this.fabricCode;
    rollsku_criteria.colorCode = this.colorCode;
    if (searchCriteria !== undefined && searchCriteria !== null) {
      rollsku_criteria.rollSkuNumber = searchCriteria.rollSkuNumber;
    }
    rollsku_criteria.purchaseReceitpNumber = this.purchaseReceiptNumber;
    let roll_sku_pageList = new RestPageListBean();
    roll_sku_pageList.pageSize = 50; //TODO --> Fetch from Config
    roll_sku_pageList.currentPage = pageNumber;
    roll_sku_pageList.pageNumber = pageNumber;
    let requestInput = new RestSkuBatchInventoryListRequest();
    requestInput.pageInput = roll_sku_pageList;
    requestInput.searchCriteria = rollsku_criteria;

    if (!isEmptyString(this.purchaseReceiptNumber)) {
      alert("purchaseReceiptNumber");
      InventoryService.getSkuBatchDetailsForPurchaseReceipt(
        requestInput,
        (response) => this.loadRollSkuPageResponse(response, lookup_dialog),
        this.loadRollSkuPageError,
      );
    } else {
      InventoryService.getSkuBatchAllWareHouseInventoryPageList(
        requestInput,
        (response) => this.loadRollSkuPageResponse(response, lookup_dialog),
        this.loadRollSkuPageError,
      );
    }
  };
  loadRollSkuPageResponse = (response, lookup_dialog) => {
    let binInventoryList = [];
    let totalCount = 0;
    let currentPageNumber = 0;
    let pageSize = 0;
    if (
      response.data.skuBatchInventoryPageList != null &&
      response.data.skuBatchInventoryPageList.skuBatchInventories !== null
    ) {
      binInventoryList =
        response.data.skuBatchInventoryPageList.skuBatchInventories;
      totalCount = response.data.skuBatchInventoryPageList.totalCount;
      currentPageNumber = response.data.skuBatchInventoryPageList.currentPage;
      pageSize = response.data.skuBatchInventoryPageList.pageSize;
    }
    // to neglate zero onhandqty
    let binInventory_List = [];
    binInventoryList.map((obj) => {
      if (obj.onHandQuantity > 0) {
        binInventory_List.push(obj);
      }
    });
    let lookup_result_details = new LookupResultDetails();
    this.lookupdata = binInventory_List;
    lookup_result_details.pageData = this.lookupdata;
    let total_count = 0;
    if (this.lookup_data != null) {
      total_count = this.lookup_data.length;
    }
    lookup_result_details.totalRecordsCount = totalCount;
    lookup_result_details.currentPageNumber = currentPageNumber;
    lookup_result_details.pageSize = pageSize;
    lookup_result_details.criteriaDisplayString = ""; //TODO
    lookup_dialog.updateResultCallBack(lookup_result_details);
  };
  loadRollSkuPageError = (error) => {
    ShowError("Error : " + error);
  };
  fetchDataFromService(lookup_dialog, pageNumber, searchCriteria, filterText) {
    let search = { ...searchCriteria };
    if (search != null && search != "unDefined") {
      if (search.rollSkuNumber == 0 || search.rollSkuNumber != undefined) {
        search.rollSkuNumber = filterText;
        this.searchCriteria = new SKUBatchInventorySearchCriteria();
      }
    }
    if (lookup_dialog != null) {
      this.loadRollSkuList(lookup_dialog, pageNumber, search);
    }
  }
}
const RollSkuLookupCriteraHandler = (companyCode) => {
  return class extends React.Component {
    constructor(props) {
      super(props);
      this.state = {
        searchCriteria: new SKUBatchInventorySearchCriteria(),
      };
      this.criteriaLookupHandler = React.createRef();
      this.focusRef = React.createRef();
    }
    componentDidMount() {
      let searchCriteria = this.state.searchCriteria;
      searchCriteria.companyCode = companyCode;
      this.setState({ searchCriteria: searchCriteria });
      if (this.focusRef.current) this.focusRef.current.focus();
    }
    continueButtonClick = () => {
      this.props.searchCriteriaCallBack(this.state.searchCriteria);
    };
    onChange = (e) => {
      let temp_searchCriteria = this.state.searchCriteria;
      temp_searchCriteria[e.target.name] = e.target.value;
      this.setState({ searchCriteria: temp_searchCriteria });
    };
    clearCriteria = () => {
      let searchCriteria = new SKUBatchInventorySearchCriteria();
      searchCriteria.companyCode = companyCode;
      this.setState({ searchCriteria: searchCriteria });
      if (this.focusRef.current) this.focusRef.current.focus();
    };
    onContainerKeyDown = (e) => {
      if (e.ctrlKey && e.keyCode == "191") {
        this.continueButtonClick();
      }
    };
    render() {
      let searchCriteria = this.state.searchCriteria;
      return (
        <div className="text-center p-2">
          <Container onKeyDown={this.onContainerKeyDown}>
            <Row>
              <Col sm={5}>
                <FormLabel>RollSkuNumber</FormLabel>
              </Col>
              <Col sm={7}>
                <InputTextbox
                  tabIndex={-1}
                  id="rollSkuNumber"
                  name="rollSkuNumber"
                  onChange={this.onChange}
                  value={searchCriteria.rollSkuNumber}
                />
              </Col>
            </Row>
            <Row></Row>
            <Row className="d-flex justify-content-center">
              <Col sm="3">
                <Button
                  className="header_buttons btn btn-primary btn-sm enterFocus"
                  onClick={this.continueButtonClick}
                  ref={this.focusRef}
                >
                  <TickIcon />
                  Continue
                </Button>
              </Col>
              <Col sm="3">
                <Button
                  className="header_buttons btn btn-primary btn-sm enterFocus"
                  onClick={this.clearCriteria}
                >
                  <Eraser />
                  Clear
                </Button>
              </Col>
            </Row>
          </Container>
        </div>
      );
    }
  };
};
